import { SafeError, SafePromise } from '@benzinga/safe-await';
import { ExtendedListenableSubscribable } from '@benzinga/subscribable';
import { Session } from '@benzinga/session';

import { TrendingTopic } from './entities';
import { createTrendingTopicsRestful, TrendingTopicsTransport } from './restful';

interface ErrorEvent {
  error?: SafeError;
  errorType: 'trending_topic_error';
  type: 'error';
}

interface TrendingTopicEvent {
  topics: TrendingTopic[];
  type: 'get_topics';
}

interface TrendingIndiaTopicsEvent {
  topics: TrendingTopic[];
  type: 'get_trending_india_topics';
}

export type TrendingTopicRequestEvent = ErrorEvent | TrendingTopicEvent | TrendingIndiaTopicsEvent;

interface TrendingTopicFunctions {
  getTopics: TrendingTopicsRequest['getTopics'];
  getTrendingIndiaTopics: TrendingTopicsRequest['getTrendingIndiaTopics'];
}

export class TrendingTopicsRequest extends ExtendedListenableSubscribable<
  TrendingTopicRequestEvent,
  TrendingTopicFunctions
> {
  private restful: TrendingTopicsTransport;

  constructor(session: Session) {
    super();
    this.restful = createTrendingTopicsRestful(session);
  }

  public getTopics = async (): SafePromise<TrendingTopic[]> => {
    const topics = await this.restful.getTrendingTopics();
    if (topics.err) {
      this.dispatch({
        error: topics.err,
        errorType: 'trending_topic_error',
        type: 'error',
      });
    } else {
      this.dispatch({
        topics: topics.ok,
        type: 'get_topics',
      });
    }
    return topics;
  };

  public getTrendingIndiaTopics = async (): SafePromise<TrendingTopic[]> => {
    const topics = await this.restful.getTrendingIndiaTopics();
    if (topics.err) {
      this.dispatch({
        error: topics.err,
        errorType: 'trending_topic_error',
        type: 'error',
      });
    } else {
      this.dispatch({
        topics: topics.ok,
        type: 'get_trending_india_topics',
      });
    }
    return topics;
  };

  protected onSubscribe(): TrendingTopicFunctions {
    return {
      getTopics: this.getTopics,
      getTrendingIndiaTopics: this.getTrendingIndiaTopics,
    };
  }
}
